<template>
	<div class="faux-modal flex bg-shade-5 flex--center flex--align">
		<div class="faux-modal__body bg-primary p pt-3">
			<div class="faux-modal__wrapper center">
				<div class="faux-modal__header text-center">
					<a v-if="!disableLogoHref" href="/" class="inline-block">
						<Inline svg="logos/stacked-logo" class="faux-modal__logo dark:hide" />
						<Inline svg="logos/stacked-hybrid-logo" class="faux-modal__logo light:hide" />
					</a>
					<div v-else class="inline-block">
						<Inline svg="logos/stacked-logo" class="faux-modal__logo dark:hide" />
						<Inline svg="logos/stacked-hybrid-logo" class="faux-modal__logo light:hide" />
					</div>
				</div>
				<slot />
			</div>
		</div>
		<CTastefulBranchName />
	</div>
</template>

<script lang="ts">
	import { defineComponent } from 'vue';
	import CTastefulBranchName from '../components/embeds/TastefulBranchName.vue';

	export default defineComponent({
		components: {
			CTastefulBranchName
		},
		props: {
			disableLogoHref: { type: Boolean, default: false }
		}
	});
</script>

<style lang="scss">
	@mixin contain-until($breakpoint) {
		width: 100%;
		min-height: 100vh;

		@include b-up($breakpoint) {
			max-width: $breakpoint - 75px;
			min-height: 0;
			margin: 1em 0;
		}
	}

	.faux-modal {
		min-height: 100vh;
		overflow: auto;

		[data-color-scheme='light'][data-has-custom-theme='false'] & {
			background: var(--shade-10);
		}

		&__logo {
			width: 128px;
		}
	}
</style>